export class GroupCIDsQueryParams {
    customIds?: string[] = [];
    projection = 'hoardingGroupProjection';
}